import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { SPONSOR_PERFORMANCE_BUBBLE } from "../keys";

const useSponsorPerformanceBubble = (sponsorObjectId) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [
      SPONSOR_PERFORMANCE_BUBBLE,
      sponsorObjectId,
      tenant.id,
      startDate,
      endDate,
    ],
    queryFn: () =>
      ApiService.getSponsorPerformanceBubble(since, until, sponsorObjectId),
    select: (data) => data.data,
    placeholderData: {data: []},
  });
};

export default useSponsorPerformanceBubble;
